import { z } from 'zod';
/**
 * MCP Tasks extension (io.modelcontextprotocol/tasks, SEP-2663, MCP spec
 * 2026-07-28). Wire shapes for the server-directed long-running-task pattern:
 * a tools/call may return a task handle (CreateTaskResult) instead of the
 * synchronous result, which the client then polls via tasks/get and may
 * cancel via tasks/cancel.
 */
export const MCP_TASKS_EXTENSION_NAME = 'io.modelcontextprotocol/tasks';
/**
 * Per-request client capabilities are declared under this `_meta` key. A
 * server must never return a task to a client that did not declare the tasks
 * extension there.
 */
export const MCP_CLIENT_CAPABILITIES_META_KEY = 'io.modelcontextprotocol/clientCapabilities';
export const MCP_TASK_STATUSES = [
    'working',
    'input_required',
    'completed',
    'failed',
    'cancelled',
];
export const MCP_TASK_TERMINAL_STATUSES = [
    'completed',
    'failed',
    'cancelled',
];
export const isMcpTaskStatusTerminal = (status) => MCP_TASK_TERMINAL_STATUSES.includes(status);
/**
 * JSON-RPC error code the extension mandates for tasks/* requests from
 * clients that did not declare the tasks capability in the request's _meta.
 */
export const MCP_ERROR_CODE_MISSING_REQUIRED_CAPABILITY = -32003;
const mcpClientCapabilitiesSchema = z.object({
    extensions: z.record(z.string(), z.unknown()).optional(),
});
/**
 * Whether the request's `_meta` declares the tasks extension in its
 * per-request client capabilities. Malformed metadata counts as not opted in.
 */
export const clientSupportsMcpTasks = (meta) => {
    if (typeof meta !== 'object' || meta === null) {
        return false;
    }
    const capabilities = meta[MCP_CLIENT_CAPABILITIES_META_KEY];
    const parsed = mcpClientCapabilitiesSchema.safeParse(capabilities);
    if (!parsed.success || parsed.data.extensions === undefined) {
        return false;
    }
    return MCP_TASKS_EXTENSION_NAME in parsed.data.extensions;
};
//# sourceMappingURL=tasks.js.map